(ns app.front.view.inspections.reassign-inspector
  (:require [app.domain.booking.model :as booking-model]
            [app.domain.group.model :as group-model]
            [app.domain.inspection.model :as inspection-model]
            [app.front.entities :as entities]
            [app.front.ui.select :as ui-select]
            [app.front.view.dispatch.subs :as dispatch-subs]
            [app.front.view.inspections.subs :as inspection-sub]
            [clojure.set :as set]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.user.model :as user-model]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::start-reassign
  (fn [{:keys [db]} [_ bookings]]
    {:dispatch [::dispatch-subs/fetch-inspectors nil :group.role/inspector]
     :db       (-> db
                   (assoc-in [::reassign :booking-ids] (mapv :db/id bookings))
                   (assoc-in [::reassign :qualifications] (->> bookings
                                                               (mapcat booking-model/required-qualifications)))
                   (assoc-in [::reassign :permit-types] (->> bookings
                                                             (map (comp :workspace/permit-type booking-model/get-workspace))
                                                             (into #{}))))}))

(rf/reg-event-db ::set-assigning-to
  (fn [db [_ user]]
    (assoc-in db [::reassign :to-user] user)))


(rf/reg-sub ::assigning-ids
  :<- [::reassign]
  :-> :booking-ids)

(rf/reg-sub ::qualifications
  :<- [::reassign]
  :-> :qualifications)

(rf/reg-sub ::permit-types
  :<- [::reassign]
  :-> :permit-types)

(rf/reg-sub ::assigning-for-groups
  :<- [::assigning-ids]
  :<- [::inspection-sub/my-bookings-for-the-selected-day]
  :<- [::inspection-sub/my-missed-bookings-for-the-selected-day]
  (fn [[ids bookings missed-bookings] _]
    (->> (-> (group-by :db/id (concat bookings missed-bookings))
             (select-keys ids)
             vals)
         (map (comp :db/id group-model/get-authority-group first))
         set)))


(rf/reg-event-db ::assign-done
  (fn [db _]
    (dissoc db ::reassign)))


(rf/reg-sub ::reassign
  :-> ::reassign)


(rf/reg-sub ::assigning-to
  :<- [::reassign]
  (fn [{:keys [to-user]} _]
    to-user))


(rf/reg-sub ::assignable-inspectors
  :<- [::dispatch-subs/visible-inspectors]
  :<- [:session/user]
  :<- [::assigning-for-groups]
  :<- [::qualifications]
  (fn [[all me assigning-group-ids qualifications] [_ authority-group-id omit-me?]]
    (let [group-ids                  (set/union assigning-group-ids
                                                (util/->set authority-group-id))
          inspector-qualification-fn (fn [inspector]
                                       (->> (inspection-model/get-inspector-qualifications inspector group-ids)
                                            vals
                                            (mapcat (partial map :db/id))
                                            set))
          required-qualifications    (->> qualifications
                                          (keep #(when (group-model/has-feature? (:domain/authority-group %)
                                                                                 :group.feature/inspection-restriction-qualification)
                                                   (:db/id %)))
                                          set)]
      (cond->> (filter #(and (set/subset? group-ids (:authority-group-ids %))
                             (set/subset? required-qualifications (inspector-qualification-fn %)))
                       all)
        omit-me? (remove (comp (partial = (:db/id me)) :db/id))))))


(rf/reg-event-fx ::do-assign
  (fn [_ [_ to-user ids]]
    {:comm/command {:command    :booking/reassign
                    :method     :post
                    :data       {:to-user-id  (:db/id to-user)
                                 :booking-ids ids}
                    :on-success [::entities/apply-changes]}}))


(defn selector [tr authority-group-id omit-me?]
  (let [inspectors (<sub [::assignable-inspectors authority-group-id omit-me?])]
    (if (empty? inspectors)
      (if (<sub [::dispatch-subs/inspectors-loading?])
        (cc/select-skeleton {})
        [:h3 (tr [:inspection/no-other-inspectors-found])])
      [:div
       [:span (tr [:inspection/reassign-help])]
       [:div.mt-4
        [ui-select/select
         {:id           "reassign-modal"
          :label-text   (tr [:inspection/reassign-select-person])
          :required     true
          :allow-empty? false
          :val->str     user-model/full-name
          :on-change    #(>evt [::set-assigning-to %])
          :value        (<sub [::assigning-to])
          :values       inspectors}]]])))
